import { render } from "./login.mobile.vue?vue&type=template&id=56b7bc22&ts=true"
import script from "./login.mobile.vue?vue&type=script&lang=ts"
export * from "./login.mobile.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__